import { useEffect, useState } from "react";
import { useScrollTo } from "@/lib/useScrollTo";

export const Header = () => {
  const scrollTo = useScrollTo();
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const links = [
    { label: "O mnie", id: "ometmnie" },
    { label: "Metoda", id: "metoda" },
    { label: "Efekty", id: "efekty" },
    { label: "Przemiana AI", id: "ai" },
    { label: "Lokalizacja", id: "lokalizacja" },
  ];

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled
          ? "bg-[#0F0E0E]/80 backdrop-blur-xl border-b border-[#2A2626]"
          : "bg-transparent border-b border-transparent"
      }`}
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 h-20 flex items-center justify-between">
        <button
          onClick={() => scrollTo("top")}
          data-testid="logo-button"
          className="flex items-center gap-2"
        >
          <span className="font-display text-2xl tracking-tight text-[#F5F2F0]">Przemiana</span>
          <span className="text-[#FF6B6B] font-display text-2xl">1:1</span>
        </button>

        <nav className="hidden md:flex items-center gap-9">
          {links.map((l) => (
            <button
              key={l.id}
              onClick={() => scrollTo(l.id)}
              data-testid={`nav-${l.id}`}
              className="text-sm text-muted hover:text-[#F5F2F0] transition-colors tracking-wide"
            >
              {l.label}
            </button>
          ))}
        </nav>

        <button
          onClick={() => scrollTo("kontakt")}
          data-testid="header-cta-button"
          className="btn-primary rounded-full px-6 py-2.5 text-xs font-semibold uppercase tracking-[0.15em]"
        >
          Umów trening
        </button>
      </div>
    </header>
  );
};
